import {PRODUCT_TYPES} from 'constants/product';
import {FetchWindowProductMSType, WindowProductMSType} from 'constants/flow/flowTypesProduct';

/**
 * Prepare fetched product data
 * @param {FetchProductType} data - fetched data
 * @return {ProductWindowType} - adapted data
 */
export const productAdapter = (data: FetchWindowProductMSType): WindowProductMSType => {
    const {children, name: parentName} = data;
    const isContactLenses = children[0].type === PRODUCT_TYPES.CONTACT_LENSES;
    return {
        ...data,
        type: children[0].type,
        isContactLenses,
        children: children.reduce(
            (acc, child) => ({
                ...acc,
                [child.id]: {
                    ...child,
                    isContactLenses,
                    parentName,
                },
            }),
            {},
        ),
    };
};
